module.exports = __webpack_public_path__ + "static/media/doodle-present.d4eba668.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doodles/mobile/doodle-present.svg
// module id = 1653
// module chunks = 50